import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-numbered-circle',
    templateUrl: './numbered-circle.component.html',
    styleUrls: ['./numbered-circle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NumberedCircleComponent {
  @Input() dataContext: number;
}
